{
  "dropzoneLabel": "Zona spuštanja",
  "selectPlaceholder": "Odaberite stavku",
  "tableResizer": "Promjena veličine",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
